import { Box, ChevronsUpDown } from 'lucide-react';

interface SidebarHeaderProps {
  projectName: string;
  instanceName: string;
  isCluster: boolean;
  isCollapsed: boolean;
}

export const SidebarHeader = ({ projectName, instanceName, isCluster, isCollapsed }: SidebarHeaderProps) => {
  return (
    <div className="p-4 flex items-center gap-3 h-16">
      <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center shrink-0 text-white">
        <Box className="w-5 h-5" />
      </div>
      {!isCollapsed && (
        <>
          <div className="flex-1 overflow-hidden">
            <div className="font-semibold text-sm truncate">{projectName || instanceName || 'RITA'}</div>
            <div className="text-xs text-muted-foreground truncate">
              {isCluster ? 'Cluster Mode' : 'Single Instance'}
            </div>
          </div>
          <ChevronsUpDown className="w-4 h-4 text-muted-foreground shrink-0" />
        </>
      )}
    </div>
  );
};
